// Hero illustration — globe wrapped in binary, magnifier over a
// glowing fingerprint. The source asset (/hero-artwork.jpg) is
// already rendered on a dark-navy backdrop matching the hero
// background, so no chroma key or alpha trickery is needed — the
// edges blend straight into the page. Mask + radial fade smooth
// the JPG's hard rectangular boundary into the surrounding gradient.

export function HeroArtwork(): JSX.Element {
  return (
    <div className="hero-artwork-wrap">
      <img
        src="/hero-artwork.jpg"
        alt="Digital forensics: globe wrapped in binary, magnifier over fingerprint"
        className="hero-artwork"
        decoding="async"
        loading="eager"
      />
    </div>
  );
}
